import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/phone-numbers')({
    component: PhoneNumbersPage,
});

// The standalone Phone numbers page was folded into the Phone setup pages;
// the route remains as a redirect for old links.
function PhoneNumbersPage() {
    return <Navigate to="/settings/phone-instructions" replace={true} />;
}
